import React from "react";
import { Search, SearchIconWrapper, StyledInputBase } from "./style";
import SearchIcon from "@mui/icons-material/Search";

const SearchGlobal = ({ sx, placeholder, value, setValue, handleSearch }) => {
  return (
    <Search sx={sx}>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>

      <StyledInputBase
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
        value={value}
        onChange={(event) => {
          const value = event.target.value;
          setValue(value);
        }}
        onKeyDown={(event) => {
            if(event.key === 'Enter') {
                handleSearch();
            }
        }}
      />
    </Search>
  );
};

export default SearchGlobal;
